import { fertilityProductFormats } from 'constants/products';
import { applicationProperties, scriptTypes } from 'constants/scripts';
import { UNIT_TYPES } from 'constants/unitTypes';
import { inferUnit } from 'util/unitConversion';

import { getProductById } from 'products/selectors';
import { getNominalWeightByCropId } from 'crops/selectors';

const getWetDryUnitValue = ({format, value}) => {
  const convertedValue = format === fertilityProductFormats.DRY
    ? inferUnit('area-density.application.dry-fertilizer', value).to(UNIT_TYPES.lbs_ac, {precision: 12})
    : inferUnit('volumetric-density', value).to(UNIT_TYPES.gal_ac, {precision: 12});
  return {q: convertedValue.scalar, u: convertedValue.unitKey };
};

const formatProductApplicationFertility = ({
  format,
  property,
  value
}) => {
  if (property === applicationProperties.NITROGEN_RATE) {
    const convertedValue = inferUnit('area-density.application', value).to(UNIT_TYPES.lbs_ac, {precision: 12});
    return { q: convertedValue.scalar, u: convertedValue.unitKey };
  } else {
    return getWetDryUnitValue({format, value});
  }
};

const formatProductApplicationCropProtection = ({
  format,
  property,
  value
}) => {
  if (property === applicationProperties.INCORPORATION_METHOD) {
    return value; // No formatting needed.
  } else {
    return getWetDryUnitValue({format, value});
  }
};

const formatProductApplicationPlanting = ({
  crop,
  property,
  state,
  value
}) => {
  if (property === applicationProperties.FERTILIZER_RATE) {
    const convertedValue = inferUnit('volumetric-density', value).to(UNIT_TYPES.gal_ac, {precision: 12});
    value = {q: convertedValue.scalar, u: convertedValue.unitKey };
  }
  if (property === applicationProperties.SEED_RATE) {
    const convertedValue = inferUnit('seed-density', value).to(UNIT_TYPES.seed_ac, {precision: 12});
    value = {q: convertedValue.scalar, u: convertedValue.unitKey };
  }
  if (property === applicationProperties.TARGET_YIELD) {
    const convertedValue = inferUnit('area-density.yield', value).to(
      UNIT_TYPES.bu_ac, {cropNominalWeight: getNominalWeightByCropId(state, crop), precision: 12}
    );
    value = {q: convertedValue.scalar, u: convertedValue.unitKey };
  }
  return value;
};

export const formatProductApplicationProperty = ({
  applicationType,
  crop,
  format,
  getState,
  product,
  property,
  scriptType,
  value
}) => {
  const state = getState();
  if (property === applicationProperties.PRODUCT) {
    if (!value && scriptType === scriptTypes.APPLICATION) {
      return formatProductApplicationCropProtection({ format, product, property, value });
    }
    return getProductById({ applicationType, id: value, state }) || null;
  } else {
    if (value === '' || value === null) { value = 0; } // Indicating "unspecified" expected value.
    if (scriptType === scriptTypes.FERTILITY) {
      value = formatProductApplicationFertility({ format, product, property, value });
    } else if (scriptType === scriptTypes.APPLICATION) {
      value = formatProductApplicationCropProtection({ format, product, property, value });
    } else {
      value = formatProductApplicationPlanting({
        crop,
        property,
        state,
        value
      });
    }
    return value;
  }
};
